import { Injectable } from '@angular/core';
import { Apollo, TypedDocumentNode } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { DocumentNode } from 'graphql';
import { PreviewModeService } from './preview-mode.service';

const TEST_CONTENT_TAG_ID = 'testExclude';

@Injectable({
    providedIn: 'root'
})
export class ContentfulService {
    constructor(private apollo: Apollo, private preview: PreviewModeService) { }
    /**
     * To query contentful to get page data
     * @param query GQL quey
     * @param variables query variables
     * @returns
     */
    public getPageData(query: DocumentNode | TypedDocumentNode<unknown, any>, variables: any = {}): Observable<any> {
        const isPreview = this.preview.isPreviewMode();
        variables.preview = isPreview;
        if(Object.hasOwn(variables, 'slug')) {
            variables.slug = this.parseSlugUrl(variables.slug)
        }
        const gqlQueryOptions: any = {
            query: query,
            variables: variables,
            // Ensure consistent behavior in SSR and browser
            errorPolicy: 'all',
        };
        
        // if preview mode, then fetch fresh data from contentful. No client caching policy will be used.
        if (isPreview) {
            gqlQueryOptions['fetchPolicy'] = "no-cache";
        } else {
            // Use cache-first for better SSR performance
            gqlQueryOptions['fetchPolicy'] = "cache-first";
        }
        
        return this.apollo.query(gqlQueryOptions).pipe(
            map(({ data, error }: any) => {
                if (error) {
                    console.error("gql query error - ", error);
                }
                return { data: isPreview ? data : this.filterTestBlogContent(data), error };
            })
        );
    }
    private filterTestBlogContent(value: unknown): unknown {
        if (Array.isArray(value)) {
            return value.map(item => this.filterTestBlogContent(item)).filter(item => item !== null);
        }
        if (!value || typeof value !== 'object') {
            return value;
        }
        const content = value as Record<string, unknown>;
        const url = content['url'];
        const isBlogContent = ['BlogArticlePage', 'BlogCategoryPage'].includes(String(content['__typename']))
            && typeof url === 'string'
            && url.split('?')[0].split('/').filter(Boolean)[0]?.toLowerCase() === 'blog';
        const metadata = content['contentfulMetadata'] as { tags?: unknown[] } | undefined;
        const hasTestTag = metadata?.tags?.some(tag => {
            if (!tag || typeof tag !== 'object') {
                return false;
            }
            return (tag as Record<string, unknown>)['id'] === TEST_CONTENT_TAG_ID;
        });
        if (isBlogContent && hasTestTag) {
            return null;
        }
        return Object.fromEntries(Object.entries(content).map(([key, item]) => [key, this.filterTestBlogContent(item)]));
    }
    private parseSlugUrl(slug: string) {
        // remove fragments from slug
        if (slug.includes('#')) {
            slug = slug.split('#')[0];
        }
        // remove qsp from slug
        return slug.split('?')[0];
    }
}